export const USER_REGISTER = 'register'
export const USER_LOGIN = 'login'
export const USER_LOGOUT = 'logout'
export const USER_VERIFY = 'verify'
export const USER_REFRESH = 'refresh'
export const USER_INIT_INFO = 'userInfo'

export const SETTINGS_INIT_DATA = 'initData'
export const SETTINGS_NEWS_CONFIG = 'newsConfig'
export const SETTINGS_NEWS_DATA = 'newsData'
export const SETTINGS_INIT_NEWS_GROUP = 'initNewsGroup'
export const SETTINGS_NEWS_GROUP_SWITCH = 'newsGroupSwitch'
export const SETTINGS_RESET = 'settingsReset'

export const STORAGE_NEWS_CONFIG_TAB_ID = 'newsConfigTabId'
export const STORAGE_REFRESH_TOKEN = 'refreshToken'
export const STORAGE_ACCESS_TOKEN = 'accessToken'



// WEBPACK FOOTER //
// ./src/store/types.js